/* @flow */
import apiRequest from 'lib/apiRequest';
import Entity from 'lib/Entity';
import ConnectedBankAccount from 'entities/ConnectedBankAccount';
import StripeBankAccount from 'entities/StripeBankAccount';
import PaymentSource from 'entities/PaymentSource';
import { cloneDeep } from 'lodash';

export const CONNECTED_BANK_ACCOUNT_TYPE = 'connected_bank_account';
export const INDIVIDUAL_BANK_ACCOUNT_TYPE = 'individual_bank_account';

export default class ExternalAccountResource extends Entity {

  parse(response: Object) {
    const request = cloneDeep(response);
    if (response['card']) {
      request['card'] = new PaymentSource(response['card']);
    }

    if (response['connected_account']) {
      request['connected_account'] = new ConnectedBankAccount(response['connected_account']);
    }

    if (response['bank_account']) {
      request['bank_account'] = new StripeBankAccount(response['bank_account']);
    }
    return request;
  }

  getDisplayName(): ?string {
    return this.get('display_name');
  }

  getName(): ?string {
    const account = this.getBankAccount();
    return (
      this.getDisplayName() ||
      account.getAccountHolderName() ||
      account.getBankName()
    );
  }

  getConnectedAccount(): ConnectedBankAccount {
    return this.get('connected_account');
  }

  getBankAccount(): StripeBankAccount {
    return this.get('bank_account');
  }

  setBankAccount(account: StripeBankAccount) {
    return this.set('bank_account', account);
  }

  getType(): string {
    return this.get('account_type');
  }

  delete() {
    return apiRequest(`/payments/payment_destinations/${this.getBankAccount().id}`, 'DELETE');
  }

  makePrimary() {
    return apiRequest(`/payments/payment_destinations/${this.getBankAccount().id}`, 'PATCH', {
      payment_destination: {
        default_for_currency: true,
      },
    }).then(account => ExternalAccountResource.fromJSON(account));
  }

  static create(token) {
    return apiRequest('/payments/payment_destinations', 'POST', { token })
      .then(account => ExternalAccountResource.fromJSON(account));
  }

}



// WEBPACK FOOTER //
// ./src/entities/ExternalAccountResource.js